import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row justify-between text-brown min-h-0 md:pl-10 overflow-y-auto" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "font-normal text-base leading-[20px] w-20 md:w-auto mx-auto mb-10 md:font-medium md:text-2xl md:leading-[32px]" }
const _hoisted_5 = { class: "md:overflow-y-auto w-full md:w-[67%] md:min-h-0 md:pr-10" }
const _hoisted_6 = { class: "font-semibold text-xl leading-[24px] mb-4" }
const _hoisted_7 = { class: "font-normal text-base leading-[20px] mb-10" }
const _hoisted_8 = { class: "font-semibold text-xl leading-[24px] mb-4" }


import { TarotDailyPredictionResponse } from "@/types/calculators";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'PredictionResult',
  props: {
    result: {}
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: __props.result.card_image,
        alt: __props.result.name,
        class: "mx-auto mb-4 md:h-[351px] md:w-[198px] w-20 h-[140px]"
      }, null, 8, _hoisted_3),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.result.name), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h4", _hoisted_6, _toDisplayString(_unref(t)("calculators.tarot.daily-card.results.card-meaning")), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(__props.result.meaning), 1),
      _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(t)("calculators.tarot.daily-card.results.today-meaning")), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.result.today, (item, idx) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "font-normal text-base leading-[20px] mb-5",
          key: idx
        }, _toDisplayString(item), 1))
      }), 128))
    ])
  ]))
}
}

})